import React, { FC, useCallback } from 'react'
import { Button } from '@wmgtech/legato'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import { FormSelect  } from 'components/Form'
import { FormTextArea } from 'components/Form/FormTextArea/FormTextArea'
import { useFeedback } from './hooks'
import { IFeedbackForm, FeedbackFormProps } from './types'
import './FeedbackForm.scss'

const OPTIONS = ['Key Performance Indicator', 'Project Information', 'Story', 'Other']

export const FeedbackForm: FC<FeedbackFormProps> = ({ onClose, projectName, artistName }) => {
  const { sendFeedback } = useFeedback()

  const onSubmit = useCallback(
    async (data: IFeedbackForm) => {
      await sendFeedback({
        ...data,
        campaign: projectName,
        artist: artistName
      })
      onClose()
    },
    [artistName, onClose, projectName, sendFeedback]
  )

  const { handleSubmit, control } = useForm<IFeedbackForm>({
    resolver: yupResolver(
      yup.object().shape({
        category: yup.string().required('This field is required'),
        message: yup.string().required('This field is required')
      })
    )
  })

  return (
    <form className="feedback-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="feedback-form__fields">
        <FormSelect
          control={control}
          fieldName="category"
          options={OPTIONS.map((value) => ({ value, label: value }))}
          placeholder="Select Category"
        />
        <FormTextArea
          control={control}
          fieldName="message"
          rows={4}
          className="feedback-form__input"
          placeholder="Please enter suggestions or comments..."
        />
      </div>
      <div className="globalized-feedback-form__footer">
        <Button
          onClick={onClose}
          label="Cancel"
          className="globalized-feedback-form__cancel"
          colorType="secondary-black"
          containerStyle="outline"
          size="md"
        />
        <Button
          label="Submit"
          className="globalized-feedback-form__submit"
          colorType="secondary-white"
          containerStyle="outline"
          size="md"
          htmlType="submit"
        />
      </div>
    </form>
  )
}
